import * as React from 'react';
import { TPAComponentProps } from '../../types';
import { ButtonProps } from '../Button';

export interface IconButtonProps extends ButtonProps, TPAComponentProps {
  icon: React.ReactNode;
  skin?: IconButtonSkins;
  theme?: IconButtonThemes;
}

export enum IconButtonSkins {
  Line = 'line',
  Full = 'full',
}

export enum IconButtonThemes {
  None = 'none',
  Box = 'box',
}
export interface IconButtonDefaultProps {
  theme: IconButtonThemes;
}
